import React, { useState, useEffect } from 'react'
import { getCustomerDomain } from '../../../redux'
import { AccountApi } from '../../../api/Account'
import { gaPageView } from '@globaleris/ui.library'
import { Button, makeStyles } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import { styles } from './customIframe.styles'
import { Sync } from '@material-ui/icons'

export interface CustomIframeProps {
  route: string
  width: string
  height: string
  allowFullScreen: boolean
  button?: boolean
}

export const CustomIframe: React.FC<CustomIframeProps> = props => {
  const [t] = useTranslation(['globalerisLibrary', 'translation', 'customIframe'])
  const useStyles = makeStyles(styles())
  const classes = useStyles()

  const [loadIframe, setLoadIframe] = useState(true)
  const apiSuffixUrl = 'https://' + getCustomerDomain()
  const [route, setRoute] = useState<string>(props.route)
  //const apiSuffixUrl = 'https://localhost:44394';

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const accountApi = new AccountApi()

  useEffect(() => {
    setRoute(props.route)

    async function Ping() {
      return await accountApi.ping()
    }

    const refreshToken = () => {
      const width = 750
      const height = 450
      const left = window.screen.width / 2 - width / 2
      const top = window.screen.height / 2 - height / 2
      const win = window.open(
        `${apiSuffixUrl}/Account/Refresh`,
        '_blank',
        `toolbar=no,scrollbars=no,resizable=yes, width=${width}, height=${height}, top=${top}, left=${left}`
      )

      const interval = setInterval(async () => {
        let refreshed = await Ping()

        if (refreshed) {
          win?.close()
        }

        if (!win || win.closed) {
          clearInterval(interval)
          setLoadIframe(true)
        }
      }, 1500)
    }

    // refreshToken();
    Ping().then(res => {
      if (!res) {
        refreshToken()
      } else {
        setLoadIframe(true)
        gaPageView(props.route)
      }
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
    // eslint-disable-next-line no-sparse-arrays
  }, [props.route])

  const refreshIframe = () => {
    setRoute('')

    setTimeout(() => {
      setRoute(props.route)
    }, 200)
  }
  return (
    <>
      {props.button && (
        <>
          <div className={classes.header}>
            <Button className={classes.button}>
              <Sync onClick={refreshIframe} className={classes.sync}></Sync>
            </Button>
          </div>
        </>
      )}

      <>
        {loadIframe && (
          <iframe
            width={props.width}
            height={props.height}
            src={route}
            allowFullScreen={props.allowFullScreen}
            frameBorder="0"
          ></iframe>
        )}
      </>
    </>
  )
}
